import type { KiliLocale } from "@/locales/fr/kili";

const kiliLocale: KiliLocale = {
  kili: {
    "pilot-oversight": {
      title: "Remote Control Management",
      messages: {
        authorized: "Remote control enabled successfully",
        "not-authorized": "Remote control disabled successfully",
      },
      form: {
        submit: "Submit",
        authorized: "Allow remote control for the entire site",
        "do-not-authorize": "Disable remote control for the entire site",
        siteId: {
          label: "Select a site",
          placeholder: "e.g. My Site",
        },
      },
    },
    support: {
      title: "Support request",
      messages: {
        success: "Support request has been sent",
      },
      form: {
        submit: "Send support request",
        siteId: {
          label: "Which site does your request concern?",
          placeholder: "E.g. My Site",
        },
        phoneNumber: {
          label: "What number can we reach the manager at?",
          placeholder: "E.g. 0301020304",
        },
        email: {
          label: "Please also provide an email (in case of unanswered calls)",
          // https://stackoverflow.com/a/77771515
          placeholder: "{'E.g. contact@voltalis.com'}",
        },
        description: {
          label: "Comment",
          placeholder: "E.g. The heaters at the site are not working",
        },
      },
    },
    "login-to-hospitality": {
      label: "Connect to Enterprise",
      redirect: "You are about to be redirected to the organization's Enterprise.",
      agreement: "The company's agreement is required to access it, and this action will be recorded.",
      cta: "Access Enterprise",
      cancel: "Cancel",
    },
    pages: {
      organization: {
        title: "Organization {orgName} details (#{orgId})",
      },
    },
    "accommodation-sites": "Accommodation Sites",
    datatable: {
      resetFilter: "Reset filters",
      search: "Search",
      site: {
        column: {
          "site-id": "Site ID",
          name: "Site name",
          organization: "Parent organization",
          "street-number": "Street number",
          street: "Street",
          "postal-code": "Postal code",
          city: "City",
        },
      },
    },
    site: {
      siteId: "Site ID",
      name: "Name",
      numDevices: "Devices count",
      orgId: "Orga. ID",
      orgName: "Orga. name",
    },
  },
};

export default kiliLocale;
